<template>
<div class="form-group" :class="[{ 'coff-input-error' : error }]" :key="uuid">

    <label htmlFor="input">
        <b>{{$t(label)}}</b>
        <slot name="label"></slot>
    </label>

    <div class="input-group">
        <tinymce :class="[{ 'p-error' : error }]" :init="tinyConfig" v-on="listeners" :value="value" :id="uuid" :disabled="disable" style="width: 100%;" :autoResize="true" />
<!--        <Textarea :class="[{ 'p-error' : error }]" v-on="listeners" :value="value" :id="uuid" :disabled="disable" style="width: 100%;" :autoResize="true"/>-->
        <span v-if="error">{{ $t(errorMessage)}}</span>
    </div>

</div>
</template>

<script>
    import Utils from "@/utils/Utils";
    import tinymce from '@tinymce/tinymce-vue';

    // Troca parágrafos por quebras de linha: o fim do parágrafo vira a quebra da
    // linha mais a linha em branco que o espaçamento do parágrafo representava
    const paragraphsToLineBreaks = (html) => {
        return html
            .replace(/<p[^>]*>/gi, '')
            .replace(/<\/p>/gi, '<br><br>')
            .replace(/(\s*<br\s*\/?>\s*)+$/i, '');
    };

    export default {
        name: "CoffInputTextEditor",

        components:{ tinymce },

        props:{
            label: {type: String, default: null},
            value: null,
            error: {type: Boolean, default: false},
            errorMessage: {type: String, default: 'field.default.error'},
            id: null,
            disable: {type: Boolean, default: false},
            configuration: {type: Object, default: () => {return {minHeight: 200}}},
            content_css: {type: String, default: null},
            skin: {type: String, default: null},
        },

        data(){
            return {
                uuid: Utils.uuid(),
                tinyConfig: {
                  min_height: this.configuration.minHeight,
                  max_height: 600,
                  width: "100%",
                  menubar: false,
                  language: this.$i18n.locale.replace('-', '_') === 'pt_BR' ? 'pt_BR' : null,
                  content_css: this.content_css,
                  skin: this.skin,
                  branding: false,
                  elementpath: false,
                  entity_encoding : "raw",
                  encoding: 'xml',
                  statusbar: false,
                  plugins: [
                    'lists link searchreplace code fullscreen table paste autoresize paste'
                  ],
                  toolbar:
                      'fullscreen | formatselect | bold italic forecolor backcolor | \
                      alignleft aligncenter alignright alignjustify | \
                      bullist numlist outdent indent | table | removeformat pastetext | code',
                  table_default_attributes: {
                    border: '1'
                  },
                  table_default_styles: {
                    'border-collapse': 'collapse', 'width': '100%'
                  },
                  table_advtab: false,
                  table_cell_advtab: false,
                  table_row_advtab: false,
                  paste_preprocess: (plugin, args) => {
                    args.content = paragraphsToLineBreaks(args.content);
                  },
                  setup: (editor) => {
                    editor.on('keydown', (event) => {
                      if(event.keyCode !== 13 || event.ctrlKey || event.altKey || event.metaKey || event.isDefaultPrevented()){
                        return;
                      }

                      // Dentro de listas o Enter continua criando um novo item
                      if(editor.dom.getParent(editor.selection.getNode(), 'li')){
                        return;
                      }

                      event.preventDefault();

                      // Enter e Shift + Enter sempre quebram a linha (<br>), nunca criam parágrafo
                      editor.execCommand('InsertLineBreak', false, event);
                    });
                  },
                }
            }
        },

        mounted() {
            if(this.id){
                this.uuid = this.id;
            }
        },
        computed: {
            listeners() {
                return {
                    ...this.$listeners,
                    InputText: event => this.$emit('Textarea', event.target.value)
                };
            },
        },

    }
</script>

<style scoped>

</style>
